export default "__VITE_ASSET__Bmjrqftf__"